export const PROMPT_SLOT_LABELS: Record<string, string> = {
  analysis: "Анализ",
  general: "Общий",
};

export const CONVERSATION_STATUS_LABELS: Record<string, string> = {
  active: "Активен",
  completed: "Завершён",
  failed: "Ошибка",
};

export const DEFAULT_LLM_PROVIDER = "deepseek" as const;
export const DEFAULT_LLM_MODEL = "deepseek-chat";
export const DEFAULT_LLM_BASE_URL = "https://api.deepseek.com";
